import ClipboardJS from 'clipboard';

const clipboard = new ClipboardJS('.js-copy-clipboard');

clipboard.on('success', (e) => {
  const trigger = e.trigger;
  trigger.classList.add('is-success');
  setTimeout(() => trigger.classList.remove('is-success'), 5000);
});

clipboard.on('error', (e) => {
  const span = e.trigger.querySelector('span');
  if (!span) return;
  const isMac = navigator.platform.toUpperCase().includes('MAC');
  const isIOS = /iPhone|iPod|iPad/i.test(navigator.platform);
  span.textContent = isIOS ? 'press copy above' : isMac ? 'cmd+c to copy' : 'ctrl+c to copy';
});
